import {https, httpsFile} from './http.js';

export function index(data, page, currentpage, fromMyPR = false) {
    return httpsFile().get(`pr-headers?page=${page}&currentpage=${currentpage}&supplier=${data.supplier}&date_from=${data.dateFrom}&date_to=${data.dateTo}&vendor_from=${data.supplierFrom}&vendor_to=${data.supplierTo}&company=${data.company}&status=${data.status}
    &user=${data.user}&pr_number=${data.pr_number}&matnr=${data.materialno}&fromMyPR=${fromMyPR}`);
}

export function store(data){
    return https().post(`pr-headers`,data);
}

export function show(id){
    return https().get(`pr-headers/${id}`);
}

export function update(id, data) {
    return httpsFile().post(`pr-headers/${id}`, data);
}

export function destroy(id){
    return https().delete(`pr-headers/${id}`);
}

export function managerApproval(id,data){
    return https().post(`manager-approval/${id}`,data);
}


export function showCancelledPR(page, currentpage,sortby,sortdir, search, supplier, startDate,endDate,plant,search_item) {
    return httpsFile().get(`showCancelledPR?page=${page}&currentpage=${currentpage}
        &sortby=${sortby}&sortdir=${sortdir}&search=${search}&search_item=${search_item}
        &supplier=${supplier}&startDate=${startDate}&endDate=${endDate}&plant=${plant}`);
}


export function exportCancelledPR(page, currentpage,sortby,sortdir, search, supplier, startDate,endDate,plant,search_item) {
    return httpsFile().get(`exportCancelledPR?page=${page}&currentpage=${currentpage}
        &sortby=${sortby}&sortdir=${sortdir}&search=${search}&search_item=${search_item}
        &supplier=${supplier}&startDate=${startDate}&endDate=${endDate}&plant=${plant}`);
}